import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import { ToastContainer, toast } from 'react-toastify';
import { bannerAPI, newsAPI, videoAPI, adsAPI, imagaeAPI, YouTubevideoAPI, BengaluruNewsAPI, KarnatakaNewsAPI, NationalNewsAPI, YouTubevideoMetroAPI } from '../../services/api';
import Header from './Header';
import Footer from './Footer';

import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

// Swiper CSS
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// React Toastify CSS
import 'react-toastify/dist/ReactToastify.css';

// ---------- Main Homepage Component ----------
const InterViews = () => {
    // State
    const [loading, setLoading] = useState(false);
    const [banners, setBanners] = useState([]);
    const [allNews, setAllNews] = useState([]);
    const [videos, setVideos] = useState([]);
    const [ads, setAds] = useState([]);
    const [temperature, setTemperature] = useState('Loading...');
    const [youtubevideos, setYouTubeVideos] = useState([]);
    const [youtubevideosmetro, setYouTubeVideosMetro] = useState([]);
    const [error, setError] = useState(null);

    const [bengaluruallNews, setBengaluruAllNews] = useState([]);
    const [karnatakaallNews, setKarnatakaAllNews] = useState([]);
    const [nationalallNews, setNationalAllNews] = useState([]);


    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        return new Date(dateStr).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });

    };





    const fetchAds = async () => {
        setLoading(true);
        try {
            const res = await adsAPI.getAll();
            setAds(res.data.data);
        } catch (error) {
            console.error("Error fetching ads:", error);
        }
        finally {
            setLoading(false);
        }
    };

    const fetchNews = async () => {
        setLoading(true);
        try {
            const res = await newsAPI.getAll();
            setAllNews(res.data.data);
        } catch (error) {
            console.error("Error fetching news:", error);
        }
        finally {
            setLoading(false);
        }
    };

    const interviews = allNews.filter(item => item.categories === 'Interviews');



    const getAds = () =>
        ads.filter(n => n.status === 'active');



    useEffect(() => {

        fetchNews();

        fetchAds();


        fetch('https://wttr.in/Bengaluru?format=j1')
            .then(res => res.json())
            .then(data => {
                setTemperature(data.current_condition[0].temp_C + '°C');
            })
            .catch(() => setTemperature('N/A'));

    }, []);


    if (loading) {
        return (
            <div className="main-content" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }



    // ---------- Render ----------
    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />

            <Header temperature={temperature} />


            {/* ===== MAIN CONTENT ===== */}
            <main>

                {/* ---------- BENGALURU NEWS ---------- */}
                <section className="trending-posts-4__area trending-posts-4__space grey-bg section-space-bottom">
                    <div className="container custom-container">
                        <div className="trending-posts-4__top heading-display__wrap">
                            <div className="section-heading__wrap">
                                <h3 className="section__title wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s">
                                    Interviews
                                </h3>
                                <div className="section__border wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s" />
                            </div>

                        </div>
                        <div className="row mb-minus-24">
                            <div className="col-lg-8">
                                <div className="trending-posts-4__wrapper mb-24">
                                    {interviews.map((item) => (
                                        <div
                                            key={item.id}
                                            className="latest-updates-2__item wow fadeInUp"
                                            data-wow-duration="0.7s"
                                            data-wow-delay="0.2s"
                                        >
                                            {/* Image container with fixed width and height */}
                                            <div
                                                className="featured-stories__thumb"
                                                style={{
                                                    width: "480px",          // fixed width
                                                    height: "auto",         // fixed height – adjust as needed
                                                    overflow: "hidden",
                                                    flexShrink: 0,           // prevent shrinking
                                                }}
                                            >
                                                <Link to="/news-details-kptv" state={{ id: item.id }}>
                                                    <img
                                                        src={item.photo ? `${imagaeAPI}/uploads/news/${item.photo}` : "assets/img/blog/noimage.jpg"}
                                                        alt={item.news_title}
                                                        style={{
                                                            width: "100%",     // fill the container
                                                            height: "100%",    // fill the container
                                                            objectFit: "cover", // crop to cover without distortion
                                                            display: "block",
                                                        }}
                                                    />
                                                </Link>
                                            </div>

                                            <div className="featured-stories__content">
                                                <h3 className="featured-stories__title">
                                                    <Link to="/news-details-kptv" state={{ id: item.id }}>
                                                        <span dangerouslySetInnerHTML={{ __html: item.news_title }} />
                                                    </Link>
                                                </h3>

                                                {item.categories !== "Interviews" && (
                                                    <div className="featured-stories__date">
                                                        <span>
                                                            {new Date(item.created_at).toLocaleDateString("en-IN")}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="col-lg-4">
                                <div className="blog-sidebar__wrapper">
                                    <div
                                        className="blog-sidebar__wrap mb-20 wow fadeInUp"
                                        data-wow-duration="0.7s"
                                        data-wow-delay="0.2s"
                                    >
                                        <h3 className="blog-sidebar__title">Advertisement</h3>
                                        <div className="blog-sidebar__gallery blog-sidebar__gallery-2">
                                            {ads.length > 0 &&
                                                ads.map((ad) => (
                                                    <div key={ad.id} className="mb-3">
                                                        <img
                                                            src={`${imagaeAPI}/uploads/ads/${ad.ads_photo}`}
                                                            alt={ad.ads_title}
                                                            className="img-fluid w-100"
                                                        />
                                                    </div>
                                                ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >














            </main >

            {/* ===== FOOTER ===== */}

            < Footer />

        </>
    );
};

// ---------- SUBCOMPONENTS ----------



export default InterViews;